import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import icEmpty from '../../../assets/images/svg/ic-empty.svg';

const MemberPerformanceEmpty = () => {
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);

  return (
    <div className="loading" style={{ margin: '350px 0' }}>
      <div className="empty">
        <img src={icEmpty} alt="icon" />
        <span>{t(`${pathKey}:datasetEmptyTitle`)}</span>
        <span style={{ marginTop: '8px' }}>
          {t(`${pathKey}:datasetEmptySubtitle`)}
        </span>
      </div>
    </div>
  );
};

export default MemberPerformanceEmpty;
